// extracted by mini-css-extract-plugin
export var bannerCallout = "timelineBannerCallout-module--bannerCallout--750Dd";
export var imgWrap = "timelineBannerCallout-module--imgWrap--UFc1U";
export var contentWrap = "timelineBannerCallout-module--contentWrap--dRKQJ";
export var bannerHeadline = "timelineBannerCallout-module--bannerHeadline--vXHB3";
export var revealContainer = "timelineBannerCallout-module--revealContainer--o4X6K";
export var imgTransformer = "timelineBannerCallout-module--imgTransformer--ryRZ0";
export var slideUp = "timelineBannerCallout-module--slideUp--YVu6j";
export var slideUpLarge = "timelineBannerCallout-module--slideUpLarge--WCBIq";